let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("28HoJ"), load("ffEVr"), load("eXOVv")]).then(() => parcelRequire('g7YcF'));